export default [
  "$stateProvider",
  "$urlRouterProvider",
  function ($stateProvider, $urlRouterProvider) {
    // Now set up the states
    $stateProvider
      .state("exchangeRateList", {
        parent: "app",
        url: "/exchangeRates?currency&dateFrom&dateUntil&downloadError",
        feature: "menu.exchangeRates",
        views: {
          main: {
            template: require("./eaExchangeRatePage/eaExchangeRatePageModule.html"),
            controller: "ExchangeRatePageModuleController as $ctrl",
          },
        },
        resolve: {
          ctrl: [
            "$q",
            "$ocLazyLoad",
            ($q, $ocLazyLoad) => {
              return $q((resolve) => {
                require.ensure([], () => {
                  let module = require("./index.js");
                  $ocLazyLoad.load({ name: module.default });
                  resolve();
                });
              });
            },
          ],
        },
      })
      .state("anonymousExchangeRates", {
        parent: "loginModule",
        url: "/exchange-Rates?currency&dateFrom&dateUntil&downloadError",

        templateProvider: [
          "$q",
          ($q) => {
            return $q((resolve) => {
              // lazy load the view
              require.ensure([], () =>
                resolve(
                  require("./eaExchangeRatePage/eaAnonymousExchangeRatePageModule.html")
                )
              );
            });
          },
        ],
        controller: "AnonymousExchangeRatePageModuleController",
        controllerAs: "$ctrl",
        resolve: {
          ctrl: [
            "$q",
            "$ocLazyLoad",
            ($q, $ocLazyLoad) => {
              //console.log("resolve module login ", $ocLazyLoad);
              return $q((resolve) => {
                require.ensure([], () => {
                  let module = require("./index.js");
                  // console.log(module.default);
                  $ocLazyLoad.load({ name: module.default });
                  resolve();
                });
              });
            },
          ],
        },
      });
  },
];



// WEBPACK FOOTER //
// ./src/ui/modules/eaExchangeRate/routes.js